const ehsan = {
  ehsanAlertMessage:
    'Because you chose Tameeni… Tameeni is by your side with Ehsan. One insurance policy that brings together protection and giving.',
  ehsanBannerMessage:
    'Through Tameeni, your insurance policies helped make an impact with Ehsan',
  learnMore: 'Learn More',
}

export default ehsan
